export default "__VITE_ASSET__BYY1Udiv__"